/* eslint semi:0 */
import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'

export const { isArray } = Array

export function toIdentityObject(member, index, inputArray) {
  this[member] = member
}

export function isSubsetOf(subsetArray, ofArray) {
  subsetArray.every(val => ofArray.indexOf(val) >= 0)
}

export function uniq(arr) {
  return [...new Set(arr)]
}

export function diff(a1, a2) {
  return a1.filter(i => a2.indexOf(i) < 0)
}

export function getRandomElement(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

export function range(rangeLength) {
  return Array.apply(null, Array(rangeLength))
}

export function flatten(arrayOfArrays) {
  const flat = [].concat(...arrayOfArrays)
  return flat.some(isArray) ? flatten(flat) : flat
}

const array = Object.assign(makeEmptyObj(), {
  toIdentityObject,
  isSubsetOf,
  uniq,
  diff,
  getRandomElement,
  isArray,
  range,
  flatten,
})

registerUtils({ array })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/array.js